export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=template&id=291c1dba"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/App.vue?vue&type=template&id=291c1dba
// module id = z3B7
// module chunks = 0